import  { useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-hot-toast";
import image from '../../../assets/images/Logo1.png'
const FormBox = ({ onClose }) => {
  const location = useLocation();
  const propertySlug = location.pathname.split("/")[1] || "......";

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const api_url = `https://backend-lead.onrender.com/api/lead/${propertySlug}`;
    
    const payload = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
    };

    try {
      const response = await fetch(api_url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        let errorMessage = "Submission failed.";
        if (response.headers.get("content-type")?.includes("application/json")) {
          const errorData = await response.json();
          errorMessage = errorData.message || errorMessage;
        }
        throw new Error(errorMessage);
      }

      // Reset form except message field
      setFormData({ name: "", email: "", phone: "", message: "" });

      toast.success(
        <div className="flex flex-col">
          <h3 className="font-semibold text-lg">Thank You For Your Interest!</h3>
          <p className="text-sm">Your enquiry has been successfully submitted.</p>
        </div>,
        {
          duration: 3000,
          position: "top-center",
          style: {
            borderRadius: "10px",
            background: "#ffffff",
            padding: "12px",
            color: "#333",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            minWidth: "30%",
            maxWidth: "350px",
            textAlign: "center",
          },
        }
      );

      onClose();
    } catch (err) {
      setError(err.message);
      toast.error("Something went wrong! Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto p-6 bg-gray-500 rounded-lg shadow-lg">
      <h3 className="text-black text-2xl text-start mb-6 font-bold">
        Connect With Us
      </h3>
      <img src={image}/>
      <form className="space-y-4 mt-4" onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            type="text"
            className="form-control w-full border border-gray-500 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Name*"
            required
          />
        </div>
        <div className="form-group">
          <input
            type="email"
            className="form-control w-full border border-gray-500 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email*"
            required
          />
        </div>
        <div className="form-group">
          <input
            type="text"
            className="form-control w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Mobile No.*"
            required
          />
        </div>
        {/* Message field (NOT sent to API) */}
        <div className="form-group">
          <textarea
            className="form-control w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Your message"
            rows="4"
          />
        </div>
        <div className="form-group">
          <button
            type="submit"
            className={`btn-default bg-black text-white py-3 px-6 rounded-lg transition w-full ${
              loading ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-800"
            }`}
            disabled={loading}
          >
            {loading ? "Submitting..." : "SUBMIT"}
          </button>
        </div>
        {error && <p className="text-red-500 text-sm text-center mt-4">{error}</p>}
      </form>
    </div>
  );
};

export default FormBox;
